import { useStorageState } from '@/src/utils/useStorageState';
import { useEffect, useState } from 'react';

export const BALANCE_EXPLAINED_SEEN_KEY = 'paygBalanceExplainedSeen';

/** Opens the modal by itself once per browser. */
export const useBalanceInfoModal = (hasSmartBalance: boolean) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSeen, setIsSeen] = useStorageState(
    BALANCE_EXPLAINED_SEEN_KEY,
    false,
  );

  useEffect(() => {
    if (!isSeen && hasSmartBalance) {
      setIsOpen(true);
      setIsSeen(true);
    }
  }, [isSeen, hasSmartBalance, setIsSeen]);

  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
  };
};
